/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import GatewayValidationStore
  from "../../../stores/GatewayManager/GatewayValidationStore";
import {useEffect, useState} from "react";
import {IGatewayRegistrationProps} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import RegistrationProgress from "./RegistrationProgress";
import {
  ICondition,
  loadOnConditionsSatisfied
} from "../../common/ConditionalLoader";
import RegistrationStatus, {IRegistrationStatusProps} from "./RegistrationStatus";
import featureFlagStore from '../../../utils/FeatureFlags/APFeatureFlagsStore';

/**
 * The interface for the properties to be passed to registration process
 */
export interface IRegistrationProcessProps extends IGatewayRegistrationProps {

  gatewayValidationStore?: GatewayValidationStore

  onContactSupport?: () => void;
}

/**
 * The component for the `RegistrationProcess`.
 * @param {IRegistrationProcessProps} props
 * @returns {any}
 * @constructor
 */
export const RegistrationProcess = (props: IRegistrationProcessProps) => {

  const [conditions, setConditions] = useState([] as ICondition[]);

  let {gatewayValidationStore, ...regProps} = props;

  const errorProps: IRegistrationStatusProps = {
    isSuccess: false,
    epName: regProps.epName,
    registeredSite: regProps.siteDetails,
    serialNumber: regProps.serialNumber,
    message: RegistrationStatus.REGISTRATION_PRECONDITIONS_FAILED,
    onContactSupport: regProps.onContactSupport!
  };

  useEffect(() => {
    let conditions: ICondition[] = [
      {
        execute: () => {
          if (featureFlagStore.getForgeDiyAppEnabled) {
            // Give the right to pass. If site has DIY role created, it is good enough
            return Promise.resolve(true);
          } else {
            // Make sure the site is of type Forge connect
            return gatewayValidationStore!.checkSiteIsIntelligentGateway(regProps.siteDetails);
          }
        }
      }
    ];
    setConditions(conditions);
  }, []);

  let ProgressComponent = loadOnConditionsSatisfied(RegistrationProgress, RegistrationStatus);

  return <ProgressComponent title="Validating Prerequisites"
                            conditions={conditions} {...regProps} {...errorProps}/>
};
